export default __webpack_public_path__ + "static/media/me1.c9d5b572.webp";